// helpers/loginStats.js
import { formatDateIndo } from "./constants";
import API from "../../../services/api";

export const buildLoginStats = (chartDataRaw) => {
  const userCounts = {};
  const roleCounts = {};
  const dailyCounts = {};
  const weeklyCounts = {};

  chartDataRaw.forEach((item) => {
    // User
    const userName = item.user?.name || "Unknown";
    userCounts[userName] = (userCounts[userName] || 0) + 1;

    // Role
    const userRole = item.user?.role || "No Role";
    roleCounts[userRole] = (roleCounts[userRole] || 0) + 1;

    // Daily
    const dateObj = new Date(item.logged_in_at);
    const dailyKey = dateObj.toISOString().split("T")[0];
    dailyCounts[dailyKey] = (dailyCounts[dailyKey] || 0) + 1;

    // Weekly
    const d = new Date(dateObj);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    const monday = new Date(d.setDate(diff));
    const weeklyKey = monday.toISOString().split("T")[0];
    weeklyCounts[weeklyKey] = (weeklyCounts[weeklyKey] || 0) + 1;
  });

  // Top Users
  const topUsersList = Object.entries(userCounts)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 10)
    .map(([name, count], index) => ({
      rank: index + 1,
      name,
      count,
    }));

  // Sorted Keys
  const sortedDailyKeys = Object.keys(dailyCounts).sort();
  const sortedWeeklyKeys = Object.keys(weeklyCounts).sort();

  return {
    topUsersList,
    roleStats: {
      labels: Object.keys(roleCounts),
      data: Object.values(roleCounts),
    },
    trendStats: {
      daily: {
        labels: sortedDailyKeys.map((d) => formatDateIndo(d, "daily")),
        data: sortedDailyKeys.map((k) => dailyCounts[k]),
      },
      weekly: {
        labels: sortedWeeklyKeys.map((d) => formatDateIndo(d, "weekly")),
        data: sortedWeeklyKeys.map((k) => weeklyCounts[k]),
      },
    },
  };
};

 export const fetchStatsData = async (
  setIsStatsLoading,
  setChartDataRaw
) => {
    setIsStatsLoading(true);
    try {
      const res = await API.get(`/login-histories?per_page=500`);
      setChartDataRaw(res.data.data);
    } catch (err) {
      console.error("Error stats:", err);
    } finally {
      setIsStatsLoading(false);
    }
  };